import React from "react";
import { string, bool } from "prop-types";

import "./checkbox.m.css";

const Checkbox = ({ text, isChecked, ...props }) => (
  <label styleName="container">
    {text}
    <input type="checkbox" checked={isChecked} {...props} />
    <span styleName="checkmark" />
  </label>
);

Checkbox.defaultProps = {
  isChecked: false
};

Checkbox.propTypes = {
  isChecked: bool,
  text: string
};

export default Checkbox;
